import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";
class UserProfileService {
  constructor() {}


  updateUserProfile(userFullName) {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/UpdateUserDetails";
    let params = {
      USR_FULL_NAME: userFullName,
       // newPassword: newPassword,
    };
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers:{
          "Content-Type": "application/json"
      }
    });
  }
  updateUserPassword(newPassword,oldPassword) {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/UpdateUserPassword";
    let params = {
      USR_PASSWORD: newPassword,
      CURRENT_USR_PASSWORD: oldPassword,
    };
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers:{
          "Content-Type": "application/json"
      }
    });
  }


  signOutUser() {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/Signout";
    let params = {
    };
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers:{
          "Content-Type": "application/json"
      }
    });
  }
  authenticate(userFullName, password) {}
}

let instance = new UserProfileService();
export default instance;
